module.exports = __webpack_public_path__ + "img/driverSalaryIntro.a077549b.png";